module.exports = __webpack_public_path__ + "static/media/qr-code-small.c55c52c1.png";